import {Injectable} from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from "rxjs";
import {StartECaseRepository} from "./start-ecase-repository";
import {ServiceSet} from "./models/service-set";
import {ECase} from "./models/ecase";
import {Action} from "./models/action";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class StartECaseService implements StartECaseRepository {
  private publicServiceURL = document["preferences"].publicServiceURL;

  constructor(private http: HttpClient) { }

  findAll(): Observable<ServiceSet[]> {
    let language = document["angular2Portlet"].language;
    return this.http.get<ServiceSet[]>(this.publicServiceURL + "startecase/" + language);
  }

  findByServiceSetIds(setIds: number[], filterByAccountGroup: boolean): Observable<ServiceSet[]> {
    let language = document["angular2Portlet"].language;
    let body = {
      setIds: setIds,
      filterByAccountGroup: filterByAccountGroup
    };
    return this.http.post<ServiceSet[]>(this.publicServiceURL + "startecase/service-sets/services/" + language, body, httpOptions);
  }

  startECase(eServiceId: number): Observable<ECase> {
    let body = {
      id: eServiceId,
      language: document['angular2Portlet'].language
    };
    return this.http.post<ECase>(this.publicServiceURL + "startecase/create/ecase", body, httpOptions);
  }

  checkActionStatus(eCaseId: number): Observable<Action> {
    return this.http.get<Action>(this.publicServiceURL + "status/fetchAction?eCaseId=" + eCaseId);
  }

}



// WEBPACK FOOTER //
// ./src/app/start-ecase-service.ts